/* eslint-disable no-process-env, no-magic-numbers */
/* eslint-disable indent */
import env from './env.js';

const setupVars = process.env || {};

export default {
  env: env,
  host: setupVars.HOST || 'http://localhost',
  port: setupVars.PORT || 3030,

  server: {
    baseUrl: setupVars.BACKEND_URL || 'http://localhost:3030'
  },

  google: {
    staticMaps: {
      apiKey: setupVars.GOOGLE_STATIC_MAPS_API_KEY || null
    }
  }
};



// WEBPACK FOOTER //
// ./src/config/main.js